'use client'

import React, { useEffect, useMemo, useRef } from 'react'
import type { FC } from 'react'
import { Button, Dropdown } from 'antd'
import SignInOrSignUp, {
  SignInOrSignUpRef,
} from '@/app/_partials/SignInOrSignUp'
import cls from 'classnames'
import { useUserStore } from '@/feature/user/store'
import { useUserInfo } from '@/api'
import useClient from '@/utils/useClient'
import userImage from '@/assets/user.svg'
import Image from 'next/image'
import { spans } from 'next/dist/build/webpack/plugins/profiling-plugin'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { ROUTE_HOME } from '@/constants/routes'
import { useFeaturesInProgress } from '@/utils'

export interface UserProps {
  className?: string
}

const User: FC<UserProps> = (props) => {
  const { className } = props

  const { show, contextHolder } = useFeaturesInProgress()

  const router = useRouter()

  const isClient = useClient()

  const userStore = useUserStore()
  const { token, userInfo, setUser } = userStore

  const signInOrSignUpRef = useRef<SignInOrSignUpRef>(null)

  const userInfoQuery = useUserInfo(Boolean(userStore.token) && isClient)

  useEffect(() => {
    if (token && userInfoQuery.isFetched && userInfoQuery.data) {
      setUser({ userInfo: userInfoQuery.data })
    }
  }, [userInfoQuery.data, userInfoQuery.isFetched, setUser, token])

  const items = [
    {
      key: 'PersonalCenter',
      label: (
        <Link
          href="/"
          onClick={(e) => {
            e.preventDefault()
            show()
          }}
        >
          个人中心
        </Link>
      ),
    },
    {
      key: 'LogOut',
      label: (
        <span
          onClick={() => {
            userStore.signOut()
            router.replace(ROUTE_HOME)
          }}
        >
          退出登录
        </span>
      ),
    },
  ]

  return (
    <>
      {isClient && userInfo ? (
        <Dropdown menu={{ items }}>
          <Button type="text" className={className}>
            <div className="flex-center gap-2.5">
              <Image className="w-5" src={userImage} alt="" />
              {userInfo.username || '匿名用户'}
            </div>
          </Button>
        </Dropdown>
      ) : (
        <Button
          type="text"
          className={className}
          onClick={() => {
            signInOrSignUpRef.current?.open()
          }}
        >
          <span className="text-white">注册 / 登录</span>
        </Button>
      )}

      <SignInOrSignUp ref={signInOrSignUpRef} />

      {contextHolder}
    </>
  )
}

export default User
